/**
 * @ngdoc Directive
 * @name vrm-validation-compare-to
 * @example
 *
 * <vrm-validation-compare-to="other.model.value.in.scope" />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmValidationMin', vrmValidationMin)
        .directive('vrmValidationMinStrict', vrmValidationMinStrict)
        .directive('vrmValidationMax', vrmValidationMax)
        .directive('vrmValidationMaxStrict', vrmValidationMaxStrict)
        .directive('vrmValidationLess', vrmValidationLess)
        .directive('vrmValidationInvalid', vrmValidationInvalid);


    function isEmpty(value) {
        return angular.isUndefined(value) || value === '' || value === null || value !== value;
    }

    function isNan(value) {
        return isNaN(parseFloat(value));
    }

    //implement it this way so we don't run the regex twice as it might hit performances
    // if format is invalid returns true
    function isValidFormat(value) {
        var stringVal = value;

        if (!isEmpty(value)) {
            if (typeof stringVal !== 'string') {
                stringVal = JSON.stringify(stringVal);
            }

            return stringVal.match(/^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/) !== null;
        }
    }

    /* @ngInject */
    function vrmValidationMinStrict() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        function link(scope, elem, attr, ctrl) {
            scope.$watch(function() {
                return scope.$eval(attr.vrmValidationMinStrict);
            }, function() {
                ctrl.$validate()
            });
            ctrl.$validators.vrmMinStrict = function(modelValue, viewValue) {
                //minstrict High value must be higher than the Clear Low alarm value
                if (isEmpty(scope.$eval(attr.vrmValidationMinStrict))) return true;
                var value = modelValue || viewValue;
                var min = scope.$eval(attr.vrmValidationMinStrict);

                if (isEmpty(value) || isNan(value) || !isValidFormat(value)) {
                    return true; // skip will be picked up by another directive
                }
                return parseFloat(value) > parseFloat(min)
            };
        }
    }

    /* @ngInject */
    function vrmValidationMin() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        function link(scope, elem, attr, ctrl) {
            scope.$watch(function() {
                return scope.$eval(attr.vrmValidationMin);
            }, function() {
                ctrl.$validate()
            });

            ctrl.$validators.vrmMin = function(modelValue, viewValue) {
                if (isEmpty(scope.$eval(attr.vrmValidationMin))) return true;
                var value = modelValue || viewValue;
                var min = scope.$eval(attr.vrmValidationMin);

                if (isEmpty(value) || isNan(value) || !isValidFormat(value)) {
                    return true; // skip
                }
                return parseFloat(value) >= parseFloat(min);
            };
        }
    }

     /* @ngInject */
    function vrmValidationLess() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        function link(scope, elem, attr, ctrl) {
            scope.$watch(function() {
                return scope.$eval(attr.vrmValidationLess);
            }, function() {
                ctrl.$validate()
            });

            ctrl.$validators.vrmLess = function(modelValue, viewValue) {
                if (isEmpty(scope.$eval(attr.vrmValidationLess))) return true;
                var value = modelValue || viewValue;
                var min = scope.$eval(attr.vrmValidationLess);
                if (isEmpty(value) || isNan(value) || !isValidFormat(value)) {
                    return true; // skip
                }
                return parseFloat(value) >= parseFloat(min)
            };
        }
    }


    /* @ngInject */
    function vrmValidationInvalid() {
        // should not be triggered except for when entering a single -
        // as all other invalid values are caught by regex
        //triggers when return value is false
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };
        function link(scope, elem, attr, ctrl) {
            scope.$watch(function () {
                return scope.$eval(attr.vrmValidationLess);
            }, function () {
                ctrl.$validate()
            });
            ctrl.$validators.vrmInvalid = function (modelValue, viewValue) {
                var value = modelValue || viewValue;
                return isValidFormat(value);
            };
        }
    }


    /* @ngInject */
    function vrmValidationMax() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        function link(scope, elem, attr, ctrl) {
            scope.$watch(function() {
                return scope.$eval(attr.vrmValidationMax);
            }, function() {
                ctrl.$validate()
            });
            ctrl.$validators.vrmMax = function(modelValue, viewValue) {
                if (isEmpty(scope.$eval(attr.vrmValidationMax))) return true;
                var value = modelValue || viewValue;
                var max =  scope.$eval(attr.vrmValidationMax);
                if (isEmpty(value) || isNan(value) || !isValidFormat(value)) {
                    return true; // skip
                }
                return parseFloat(value) <= parseFloat(max)
            };
        }
    }

    /* @ngInject */
    function vrmValidationMaxStrict() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        function link(scope, elem, attr, ctrl) {
            scope.$watch(function() {
                return scope.$eval(attr.vrmValidationMaxStrict);
            }, function() {
                ctrl.$validate()
            });
            ctrl.$validators.vrmMaxStrict = function(modelValue, viewValue) {
                if (isEmpty(scope.$eval(attr.vrmValidationMaxStrict))) return true;
                var value = modelValue || viewValue;
                var max = isEmpty(scope.$eval(attr.vrmValidationMaxStrict)) ? Infinity : scope.$eval(attr.vrmValidationMaxStrict);
                if (isEmpty(value) || isNan(value) || !isValidFormat(value)) {
                    return true; // skip
                }
                return parseFloat(value) < parseFloat(max)
            };
        }
    }
})();
